// extracted by mini-css-extract-plugin
export default {"container":"AnimatedLayout_container__v3VqR","glow":"AnimatedLayout_glow__maWMd"};